import { useTranslation } from 'react-i18next';
import ETiny from 'components/editors/ETiny';
import Editor from 'components/editors/Editor';
import { useRef } from 'react';
import conf from 'conf/conf';

interface LeadEventInfoProps {
    newEvent: any;
    setNewEvent: React.Dispatch<React.SetStateAction<any>>;
    disabled?: boolean;
}

const LeadEventInfo = ({ newEvent, setNewEvent, disabled = false }: LeadEventInfoProps) => {
    const { t } = useTranslation(['Leads']);
    const refEdit = useRef<any>(null);
    const TinyEditor = (conf.tinyMode ? ETiny : Editor) as any;

    return (
        <div className="mb-3">
            <label className="form-label text-muted">{t('leadStatus.labelInfo')}</label>
            <TinyEditor
                ref={refEdit}
                autoFucus={true}
                disabled={disabled}
                value={newEvent?.eventInfo}
                onChange={(newValue: string) => {
                    if (newEvent)
                        setNewEvent((prev: any) => ({
                            ...prev,
                            eventInfo: newValue,
                        }));
                }}
            />
        </div>
    );
};

export default LeadEventInfo;
